module.exports = __webpack_public_path__ + "static/sol-section-2-img-0077175f6830139306de7e3842dcbae0.png";